import { ConsignmentWarningLetterListPage } from "@/features/consignment-warning-letter/pages/ConsignmentWarningLetterListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-warning-letter/")({
	component: ConsignmentWarningLetterListPage,
});
